import React from 'react';

const StudentPortalIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="c-StudentPortalIcon"
  >
    <path
      d="M4 10V17H7V10H4ZM10 10V17H13V10H10ZM2 22H21V19H2V22ZM16 10V17H19V10H16ZM11.5 1L2 6V8H21V6L11.5 1Z"
      fill="white"
    />
  </svg>
);

export default StudentPortalIcon;
